import { axiosInstance } from "lib/axios";
import { searchAPI } from "services/apis.service";

export const fetchQuickSearchResults = async (forceRefresh = false) => {
  const response = await axiosInstance.post(
    searchAPI.quickSearch,
    {
      numberToSelect: 6,
    },
    forceRefresh
      ? {
          cache: false,
        }
      : undefined
  );
  return response.data.data;
};
